import type { BaseProductData, VariantFilters } from '../types';
import getProductFilterValues from '../util/getProductFilterValues';
import type { SelectDropdownOptions } from '../../core/components/input/Select/SelectDropdown';

const useFilterValuesToOptions = (filterValues: {
    [name: string]: {
        type: string;
        value: string[];
    };
}) => {
    let showVariantsFilter = false;
    let showSiblingFilter = false;

    const options: { [name: string]: SelectDropdownOptions[] } = {};

    for (const [name, { type, value }] of Object.entries(filterValues)) {
        options[name] = value.map(item => ({
            label: item.toUpperCase(),
            value: item,
        }));

        if (type === 'sibling' && value.length > 0) {
            showSiblingFilter = true;
        }

        if (type === 'variant' && value.length > 0) {
            showVariantsFilter = true;
        }
    }

    return {
        showVariantsFilter,
        showSiblingFilter,
        options,
    };
};

const useProductVariantsFilterOptions = (
    products: BaseProductData[],
    filters: VariantFilters
) => {
    const validFilterValues = getProductFilterValues(products, filters);
    const { showVariantsFilter, showSiblingFilter, options } =
        useFilterValuesToOptions(validFilterValues);

    const shouldShowSiblingsColumn = products.length > 1;
    const shouldShowVariantsColumn = products.some(
        /* istanbul ignore next -- @preserve */
        ({ variants }) => variants.length > 1
    );

    const totalFiltersCount = Object.keys(options).length;

    return {
        options,
        shouldShowSiblingsColumn,
        shouldShowVariantsColumn,
        showVariantsFilter,
        showSiblingFilter,
        totalFiltersCount,
    };
};

export default useProductVariantsFilterOptions;
